// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"MapAvatar_Avatar__3M3Y0","FirstLetter":"MapAvatar_FirstLetter__2lpAE","DeadIcon":"MapAvatar_DeadIcon__3Bsdv"};